import React from 'react';
import { Tooltip, IconButton, Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const passwordRules = [
  'At least 8 characters',
  'At least one uppercase letter (A-Z)',
  'At least one lowercase letter (a-z)',
  'At least one number (0-9)',
  'At least one special character (!@#$%^&*()_+-=[]{}|;:,.<>?)',
  'No 3 or more consecutive identical characters',
  'No common sequences like "123", "abc", etc.'
];

const PasswordRulesTooltip = ({ placement = 'right', iconSx = {} }) => (
  <Tooltip
    title={
      <Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Password must contain:
        </Typography>
        <List dense sx={{ pl: 1 }}>
          {passwordRules.map((rule, idx) => (
            <ListItem key={idx} sx={{ py: 0 }}>
              <ListItemIcon sx={{ minWidth: 28 }}>
                <CheckCircleOutlineIcon color="action" fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body2">{rule}</Typography>} />
            </ListItem>
          ))}
        </List>
      </Box>
    }
    arrow
    placement={placement}
  >
    <IconButton size="small" sx={{ ml: 0.5, ...iconSx }} tabIndex={-1}>
      <InfoOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

export default PasswordRulesTooltip; 